"use client";

import React from "react";
export default function TransparentPricing() {
  return null;
}